import React, { useState } from 'react';
import './CommunitySection.css';

const CommunitySection = () => {
  const [selectedGenre, setSelectedGenre] = useState('fusion');
  const [selectedRegion, setSelectedRegion] = useState('All');
  const [selectedTag, setSelectedTag] = useState('#trending1');

  const genres = ['All', 'Rock/Pop', 'Electronics', 'Hiphop', 'fusion'];
  const regions = ['All', 'Seoul', 'Gyeonggi', 'Incheon', 'Busan'];
  const tags = ['#trending1', '#trending2', '#trending3', '#trending4', '#trending5', '#trending6'];

  // Community cards data
  const communityCards = [
    {
      id: 1,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 2,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 3,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 4,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 5,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 6,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    }
  ];

  const handleFilterClick = (filterType, value) => {
    switch (filterType) {
      case 'genre':
        setSelectedGenre(value);
        break;
      case 'region':
        setSelectedRegion(value);
        break;
      case 'tag':
        setSelectedTag(value);
        break;
      default:
        break;
    }
  };

  return (
    <section className="community" id="community">
      <div className="container">
        <div className="section-header">
          <h2>Community</h2>
        </div>
        
        {/* Filter Section */}
        <div className="filter-section">
          <div className="filter-container">
            {/* Genre Filter */}
            <div className="filter-group">
              <div className="filter-label">Genre</div>
              <div className="filter-tags">
                {genres.map((genre) => (
                  <button
                    key={genre}
                    className={`filter-tag ${selectedGenre === genre ? 'active' : ''}`}
                    onClick={() => handleFilterClick('genre', genre)}
                  >
                    {genre}
                  </button>
                ))}
              </div>
            </div>

            {/* Region Filter */}
            <div className="filter-group">
              <div className="filter-label">Region</div>
              <div className="filter-tags">
                {regions.map((region) => (
                  <button
                    key={region}
                    className={`filter-tag ${selectedRegion === region ? 'active' : ''}`}
                    onClick={() => handleFilterClick('region', region)}
                  >
                    {region}
                  </button>
                ))}
              </div>
            </div>

            {/* Tags Filter */}
            <div className="filter-group">
              <div className="filter-label">Tags</div>
              <div className="filter-tags">
                {tags.map((tag) => (
                  <button
                    key={tag}
                    className={`filter-tag ${selectedTag === tag ? 'active' : ''}`}
                    onClick={() => handleFilterClick('tag', tag)}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Community Cards Grid */}
        <div className="community-grid">
          {communityCards.map((community) => (
            <div key={community.id} className="community-card">
              <div className="community-image">
                <img src={community.image} alt={community.name} />
                <div className="community-label">{community.label}</div>
              </div>
              <div className="community-info">
                <h3 className="community-name">{community.name}</h3>
                <p className="community-description">{community.description}</p>
                <p className="community-hashtags">{community.hashtags}</p>
                <div className="community-footer">
                  <div className="participants">
                    <i className="fas fa-user"></i>
                    <span>{community.participants}</span>
                  </div>
                  <button className="join-btn">JOIN</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
